import 'react-app-polyfill/stable';
import * as Sentry from '@sentry/react';
import { excludeGraphQLFetch } from 'apollo-link-sentry';
import type { AxiosError } from 'axios';
import ReactDOM from 'react-dom';

import { App } from './App';
import { loadTrackers } from './support/tracking';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://95926e24757b46c7bab55f8f49f72857@sentry.io/1218778',
    release: process.env.REACT_APP_VERSION,
    environment: window.location.host === 'play.instruqt.dev' ? 'development' : 'production',
    allowUrls: ['instruqt.com', 'instruqt.dev'],
    normalizeDepth: 5,
    beforeBreadcrumb: excludeGraphQLFetch,
    // ResizeObserver errors are benign, see: https://stackoverflow.com/a/50387233/2106835
    // Object not found matching ID errors are the result of a browser plugin: https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/29
    ignoreErrors: ['ResizeObserver loop limit exceeded', 'Object Not Found Matching Id'],
    beforeSend(event, hint) {
      const error = hint.originalException;

      // Drop errors originating from Axios network errors.
      // See: https://www.npmjs.com/package/axios#handling-errors
      if (error && (error as AxiosError).response) {
        return null;
      } else if (error && (error as AxiosError).request) {
        return null;
      }

      return event;
    },
  });
}

loadTrackers();

ReactDOM.render(<App />, document.getElementById('root'));
